export const navData = [
  {
    id: 1,
    name: '首页',
    path: '/',
    children: []
  },
  {
    id: 2,
    name: '学校概况',
    path: '',
    children: [
      { id: 21, name: '学校简介', path: '/school/intro', icon: 'icon-xuexiaojianjie' },
      { id: 22, name: '办学特色', path: '/school/features', icon: 'icon-banxuetese1x' },
      { id: 23, name: '学校荣誉', path: '/school/honors', icon: 'icon-rongyu' },
      { id: 24, name: '技能大赛', path: '/school/skillcompetition', icon: 'icon-jinengdasai' },
      { id: 25, name: '校园风光', path: '/school/campus', icon: 'icon-xiaoyuanfengguang' },
      { id: 26, name: '企业办学', path: '/school/enterprise', icon: 'icon-qiye' }
    ]
  },
  {
    id: 3,
    name: '机构设置',
    path: '',
    children: [
      { id: 31, name: '学校办公室', path: '/organization/office', icon: 'icon-bangongshi' },
      { id: 32, name: '招生就业部', path: '/organization/admission', icon: 'icon-zhaoshengjiuyechu' },
      { id: 33, name: '学生工作部', path: '/organization/student', icon: 'icon-xueshenggongzuochu' },
      { id: 34, name: '教学部', path: '/organization/teaching', icon: 'icon-shixunjiaoxueguanli' },
      { id: 35, name: '后勤部', path: '/organization/logistics', icon: 'icon-houqinbu' }
    ]
  },
  {
    id: 4,
    name: '专业设置',
    path: '',
    children: [
      { id: 41, name: '机电技术应用', path: '/majors/mechatronics', icon: 'icon-jidianclassify' },
      { id: 42, name: '新能源汽车运用与维修', path: '/majors/newenergy', icon: 'icon-xinnengyuanqichechanye' },
      { id: 43, name: '直播电商服务', path: '/majors/ecommerce', icon: 'icon-dianshangfuwu' },
      { id: 44, name: '计算机网络技术', path: '/majors/network', icon: 'icon-jisuanjiyuwangluojishu' },
      // { id: 45, name: '医学检验技术', path: '/majors/medicallab', icon: 'icon-yixuejianyanke' },
      { id: 46, name: '高星级饭店运营与管理', path: '/majors/hotel', icon: 'icon-canyin' },
      { id: 47, name: '工业机器人技术应用', path: '/majors/robot', icon: 'icon-gongyejiqiren' },
      { id: 48, name: '人工智能技术与应用', path: '/majors/ai', icon: 'icon-zhinengshibierengongzhineng' }
    ]
  },
  {
    id: 5,
    name: '学生工作',
    path: '',
    children: [
      { id: 51, name: '团委', path: '/advantages/youthleague', icon: 'icon-xiaotuanwei' },
      { id: 52, name: '资助中心', path: '/advantages/funding', icon: 'icon-zizhu' },
      { id: 53, name: '学生管理规定', path: '/advantages/regulations', icon: 'icon-xueshengguanli' }
    ]
  },
  {
    id: 6,
    name: '教学教研',
    path: '',
    children: [
      { id: 61, name: '教学管理', path: '/teaching/management', icon: 'icon-shixunjiaoxueguanli' },
      { id: 62, name: '实训中心', path: '/teaching/training', icon: 'icon-shixunzhongxin' },
      { id: 63, name: '教研教改', path: '/teaching/research', icon: 'icon-jiaoyanhuodong' },
      { id: 64, name: '教育质量年度报告', path: '/teaching/report', icon: 'icon-niandubaogao' }
    ]
  },
  {
    id: 7,
    name: '招生就业',
    path: '',
    children: [
      { id: 71, name: '招生简章', path: '/admission/guide', icon: 'icon-zhaoshengjianzhang2' },
      { id: 72, name: '就业信息', path: '/admission/employment', icon: 'icon-biaozhunjiuyexinxi' },
      { id: 73, name: '毕业生风采', path: '/admission/graduate', icon: 'icon-biyeshengjiaoyu' }
    ]
  },
  {
    id: 8,
    name: '合作交流',
    path: '',
    children: [
      { id: 81, name: '合作交流概述', path: '/cooperation/overview', icon: 'icon-gaishu' },
      { id: 82, name: '校企合作', path: '/cooperation/enterprise', icon: 'icon-xiaoqihezuoshenhe' },
      { id: 83, name: '校校合作', path: '/cooperation/school', icon: 'icon-xiaoqihezuo' },
      { id: 84, name: '社会服务与技能培训', path: '/cooperation/service', icon: 'icon-shehuifuwu' },
      { id: 85, name: '来访互访交流', path: '/cooperation/exchange', icon: 'icon-laifang' },
      { id: 86, name: '合作洽谈预约', path: '/cooperation/reservation', icon: 'icon-wodeyuyue' }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/data/navData.js